import { envCommonIsLoadedSelector, envIsAuthorizedSelector } from 'domain/env/selectors';
import {
  thunkClickGlobalAlert,
  thunkDismissGlobalAlert,
  thunkFetchGlobalAlerts,
} from 'domain/globalAlerts/effects';
import { globalAlertsVisibleSelector } from 'domain/globalAlerts/selectors';
import { useCallback, useEffect } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { createStructuredSelector } from 'reselect';

const selector = createStructuredSelector({
  alerts: globalAlertsVisibleSelector,
  isAuthorized: envIsAuthorizedSelector,
  isLoaded: envCommonIsLoadedSelector,
});

export default function useGlobalAlerts() {
  const dispatch = useDispatch();
  const { alerts, isAuthorized, isLoaded } = useMappedState(selector);

  useEffect(() => {
    if (isLoaded && isAuthorized) {
      dispatch(thunkFetchGlobalAlerts());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, isAuthorized]);

  const onDismiss = useCallback((id: number) => dispatch(thunkDismissGlobalAlert(id)), [dispatch]);
  const onCtaClick = useCallback((id: number) => dispatch(thunkClickGlobalAlert(id)), [dispatch]);

  return { alerts, onDismiss, onCtaClick };
}
